import { render } from "./MicrowaveIcon.vue?vue&type=template&id=3339823c"
import script from "./MicrowaveIcon.vue?vue&type=script&lang=js"
export * from "./MicrowaveIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__